import { render, staticRenderFns } from "./Foreign.vue?vue&type=template&id=8213bd62&scoped=true"
import script from "./Foreign.vue?vue&type=script&lang=ts"
export * from "./Foreign.vue?vue&type=script&lang=ts"
import style0 from "./Foreign.vue?vue&type=style&index=0&id=8213bd62&prod&lang=scss&scoped=true"
import style1 from "./Foreign.vue?vue&type=style&index=1&id=8213bd62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8213bd62",
  null
  
)

export default component.exports